const W = "/work/";

export const NAV = [
  { id: "work", label: { es: "Gráfica", en: "Graphic" } },
  { id: "social", label: { es: "Social media", en: "Social media" } },
  { id: "motion", label: { es: "Motion", en: "Motion" } },
  { id: "tutorials", label: { es: "Tutoriales", en: "Tutorials" } },
  { id: "photo", label: { es: "Foto", en: "Photo" } },
  { id: "about", label: { es: "Sobre mí", en: "About" } },
  { id: "resume", label: { es: "Resume", en: "Resume" } },
  { id: "contact", label: { es: "Contacto", en: "Contact" } },
];

export const HERO = {
  eyebrow: { es: "Diseñadora gráfica senior — Branding, contenido & motion", en: "Senior graphic designer — Branding, content & motion" },
  tagline: { es: "diseña marcas que se mueven.", en: "designs brands that move." },
  sub: {
    es: "Más de 10 años impulsando marcas en todo el mundo, de Santiago a Nueva York. Identidad, campañas sociales y contenido audiovisual con estrategia y alma.",
    en: "10+ years boosting brands worldwide, from Santiago to New York. Identity, social campaigns and audiovisual content built with strategy and soul.",
  },
  cta1: { es: "Ver trabajos", en: "See selected work" },
  cta2: { es: "Hablemos", en: "Let's talk" },
  badge: { es: "DISEÑO QUE SE MUEVE • BRANDING • MOTION • SOCIAL • ", en: "DESIGN THAT MOVES • BRANDING • MOTION • SOCIAL • " },
  scroll: { es: "Desliza", en: "Scroll" },
};

export const MARQUEE = ["Branding", "Motion Graphics", "Social Media", "Art Direction", "Campaigns", "Editorial", "New York"];

export const STATS = [
  { value: "8M+", label: { es: "vistas en TikTok con una sola campaña", en: "TikTok views from a single campaign" } },
  { value: "+175%", label: { es: "engagement en 3 meses", en: "engagement in 3 months" } },
  { value: "+138%", label: { es: "seguidores en 1 año", en: "followers in 1 year" } },
  { value: "2.3M", label: { es: "visualizaciones en Reels y TikTok", en: "Reels & TikTok views" } },
  { value: "1.2M", label: { es: "impresiones en 1 mes", en: "impressions in 1 month" } },
  { value: "10+", label: { es: "años creando marcas", en: "years building brands" } },
];

export const PROJECTS = [
  {
    id: "egg-donor",
    cat: "campaigns",
    client: "Shady Grove Fertility",
    title: "Egg Donor",
    tags: ["Social", "Video", "TikTok"],
    stage: "egg",
    summary: {
      es: "Campaña social para impulsar la donación de óvulos: más visibilidad, nuevas donantes y una comunidad digital más fuerte alrededor de la causa.",
      en: "A social campaign to encourage egg donation: more visibility, new donors and a stronger digital community around the cause.",
    },
    strategy: {
      es: "Video viral con una canción pegadiza y un mensaje humano, optimizado para TikTok con llamados a la acción claros hacia la web y el formulario.",
      en: "A viral video with a catchy song and a humane message, optimised for TikTok with clear calls-to-action to the website and sign-up form.",
    },
    results: {
      es: ["Más de 8 millones de vistas en TikTok", "La web y el formulario colapsaron por el tráfico", "Gran aumento de seguidores y engagement", "Más conciencia y nuevas donantes"],
      en: ["8M+ views on TikTok", "Website and form crashed from the traffic", "Significant growth in followers and engagement", "More awareness and new donors"],
    },
    kpi: "8M+",
    gallery: [W + "egg_cut.png", W + "sm_visuals.png", W + "p5.png"],
  },
  {
    id: "savvy",
    cat: "branding",
    client: "Savvy Llama — New York",
    title: { es: "Starter kit de vino", en: "Wine starter kit" },
    tags: ["Branding", "Packaging", "Video"],
    stage: "savvy",
    summary: {
      es: "Identidad aplicada al starter kit de Savvy Llama: caja, tarjetas, folleto educativo sobre vino, fotografía de producto y video.",
      en: "Identity applied to the Savvy Llama starter kit: box, cards, wine education booklet, product photography and video.",
    },
    strategy: {
      es: "Rosa empolvado, dorados y tipografía elegante para que aprender de vino se sienta como abrir un regalo.",
      en: "Dusty pink, gold and elegant type so learning about wine feels like opening a gift.",
    },
    results: {
      es: ["Packaging y piezas impresas del kit", "Fotografía y video de producto", "Contenido para redes y e-commerce"],
      en: ["Kit packaging and printed pieces", "Product photography and video", "Content for social and e-commerce"],
    },
    kpi: "NYC",
    video: "/video/savvy_kit.mp4",
    gallery: [`${W}savvy/i2.jpg`, `${W}savvy/i1.jpg`, `${W}savvy/stand_6.jpg`, `${W}savvy/stand_9.jpg`],
  },
  {
    id: "better-brew",
    cat: "branding",
    client: "Better Brew",
    title: { es: "Better Brew — Cafetería", en: "Better Brew — Coffee Shop" },
    tags: ["Branding", "Packaging", "Illustration"],
    stage: "cafe",
    summary: {
      es: "Identidad completa para una cafetería: logotipo, un personaje ilustrado —el vasito que camina— y una paleta verde, terracota y crema.",
      en: "A full identity for a coffee shop: logotype, an illustrated character —the walking cup— and a green, terracotta and cream palette.",
    },
    strategy: {
      es: "Un sistema cálido y con humor que funciona en cualquier punto de contacto: packaging, vasos, uniformes, cartelería y vitrinas.",
      en: "A warm, playful system that works at every touchpoint: packaging, cups, uniforms, posters and shop windows.",
    },
    results: {
      es: ["Logotipo y personaje ilustrado", "Packaging de café y bolsas", "Vasos, uniformes y merch", "Cartelería, vitrinas y redes"],
      en: ["Logotype and illustrated character", "Coffee packaging and bags", "Cups, uniforms and merch", "Posters, windows and social"],
    },
    kpi: "F&B",
    video: "/video/brew.mp4",
    gallery: ["cafe_8", "cafe_2", "cafe_3", "cafe_7", "cafe_4", "cafe_9", "cafe_1", "cafe_5", "cafe_6"].map((c) => W + "cafe/" + c + ".jpg"),
  },
  {
    id: "identities",
    cat: "branding",
    client: "Minieri · Kekse · Adela Camus · Sirius · Tulahuén · Ikigai",
    title: { es: "Identidades de marca", en: "Brand Identities" },
    tags: ["Branding", "Identity", "Systems"],
    stage: "identity",
    summary: {
      es: "Sistemas de identidad para marcas de distintos rubros: logotipos, paletas y aplicaciones que se sostienen en cualquier soporte.",
      en: "Identity systems for brands across industries: logotypes, palettes and applications that hold up on any surface.",
    },
    strategy: {
      es: "Cada marca parte de su esencia: formas simples, tipografía con carácter y un sistema flexible para papelería, digital y producto.",
      en: "Every brand starts from its essence: simple forms, characterful type and a flexible system for stationery, digital and product.",
    },
    results: {
      es: ["Logotipos y sistemas visuales completos", "Aplicaciones en papelería y merchandising", "Mockups fotográficos de presentación"],
      en: ["Full logotypes and visual systems", "Stationery and merchandise applications", "Photographic presentation mockups"],
    },
    kpi: "06",
    gallery: [W + "mock_stationery.jpg", W + "gd/mock_kekse.jpg", W + "gd/mock_adela.jpg", W + "gd/mock_sirius.jpg", W + "gd/mock_tulahuen.jpg", W + "mock_ikigai.jpg"],
  },
  {
    id: "vmware",
    cat: "flyers",
    client: "VMware · Veritas · Veeam · Pure Storage · Forcepoint",
    title: { es: "Flyers tech & eventos", en: "Tech & event flyers" },
    tags: ["Advertising", "Digital", "OOH"],
    stage: "posters",
    summary: {
      es: "Flyers y pósters para marcas tecnológicas y sus eventos: invitaciones, after offices, lanzamientos y piezas para vía pública.",
      en: "Flyers and posters for tech brands and their events: invitations, after-office parties, launches and out-of-home pieces.",
    },
    strategy: {
      es: "Fotografía corporativa cálida cortada por planos de color de marca, para que cada pieza se reconozca al instante en el feed.",
      en: "Warm corporate photography sliced by brand colour planes, so every piece is instantly recognisable in the feed.",
    },
    results: {
      es: ["Serie coherente de piezas verticales", "Adaptable a redes, display y exterior", "Mockup conceptual en el metro de Nueva York"],
      en: ["A coherent series of vertical pieces", "Adaptable to social, display and outdoor", "Concept mockup in the New York subway"],
    },
    kpi: "OOH",
    gallery: [W + "mock_billboard.jpg", W + "f1.png", ...[29, 28, 36, 27, 30, 31, 34, 35, 32, 33].map((n) => `${W}gd/w${n}.jpg`)],
  },
  {
    id: "feed",
    cat: "feed",
    client: { es: "Clientes de salud y lifestyle", en: "Health & lifestyle clients" },
    title: { es: "Rediseño de feeds", en: "Feed Redesign" },
    tags: ["Social Media", "Content", "Copy"],
    stage: "laptop",
    summary: {
      es: "Visuales y captions: combino creatividad, estrategia y voz de marca para crear contenido que capta la atención y transmite un mensaje claro.",
      en: "Visuals & captions: I combine creativity, strategy and brand voice to create content that grabs attention and lands a clear message.",
    },
    strategy: {
      es: "Antes y después: retícula ordenada, paleta consistente y una escritura adaptada a la personalidad de cada marca para impulsar la comunidad.",
      en: "Before and after: an ordered grid, a consistent palette and copy adapted to each brand's personality to grow the community.",
    },
    results: {
      es: ["Feeds coherentes y reconocibles", "Más interacción y comentarios", "Identidad reforzada en redes"],
      en: ["Coherent, recognisable feeds", "More interaction and comments", "Stronger identity on social"],
    },
    kpi: "+138%",
    gallery: [W + "p1.png", W + "p2.png", W + "p3.png", W + "p4.png", W + "p6.png"],
  },
  {
    id: "mens-fertility",
    cat: "campaigns",
    client: "Dr. Adela Camus",
    title: { es: "Fertilidad masculina", en: "Men's Fertility" },
    tags: ["Education", "Social", "Health"],
    stage: "mens",
    summary: {
      es: "Campaña educativa para concientizar sobre la infertilidad masculina y ampliar el alcance de la clínica en redes sociales.",
      en: "An educational campaign raising awareness about male infertility and expanding the clinic's reach on social media.",
    },
    strategy: {
      es: "Post informativo con un mensaje cercano y llamado a la acción, optimizado para generar comentarios y compartidos.",
      en: "An informative post with a relatable message and call-to-action, optimised to encourage comments and shares.",
    },
    results: {
      es: ["Más engagement y comentarios", "Crecimiento de seguidores", "Contenido muy compartido y más visibilidad"],
      en: ["More engagement and comments", "Follower growth", "Widely shared content and more visibility"],
    },
    kpi: "+175%",
    gallery: [W + "men_cut.png", W + "infl.png"],
  },
  {
    id: "austin",
    cat: "editorial",
    client: "Austin Ingenieros Chile",
    title: { es: "Brochures & catálogos", en: "Brochures & catalogues" },
    tags: ["Editorial", "Print", "Events"],
    stage: "brochure",
    summary: {
      es: "Identidad corporativa, catálogos y stands para ferias mineras como Exponor y Expomin, liderando el área de diseño en Chile.",
      en: "Corporate identity, catalogues and stands for mining fairs such as Exponor and Expomin, leading the design area in Chile.",
    },
    strategy: {
      es: "Un sistema editorial en burdeo con fotografía de producto potente, llevado del papel al espacio físico de la feria.",
      en: "A burgundy editorial system with strong product photography, carried from print into the physical fair space.",
    },
    results: {
      es: ["Brochures y catálogos de producto", "Stands para Exponor y Expomin", "Posicionamiento de marca en el mercado chileno"],
      en: ["Product brochures and catalogues", "Stands for Exponor and Expomin", "Brand positioning in the Chilean market"],
    },
    kpi: "B2B",
    gallery: [W + "mock_brochure.jpg", ...[13, 12, 16, 17, 19, 20, 21, 22].map((n) => `${W}gd/w${n}.jpg`)],
  },
  {
    id: "ads",
    cat: "ads",
    client: "Adistec · Intel · VMware · Veeam · Quest · Pure Storage",
    title: { es: "Banners & email marketing", en: "Banners & email marketing" },
    tags: ["Advertising", "Email", "Web"],
    stage: "banners",
    summary: {
      es: "Banners web y cabeceras de email para campañas de marcas tecnológicas: mensajes claros, jerarquía fuerte y la identidad de cada partner.",
      en: "Web banners and email headers for tech brand campaigns: clear messages, strong hierarchy and each partner's identity.",
    },
    strategy: {
      es: "Un sistema modular que se adapta a cada marca y formato, para producir piezas rápidas sin perder coherencia.",
      en: "A modular system that adapts to every brand and format, to produce pieces fast without losing consistency.",
    },
    results: {
      es: ["Series de banners para email y web", "Adaptación a múltiples marcas partner", "Piezas promocionales impresas"],
      en: ["Banner series for email and web", "Adapted to multiple partner brands", "Printed promotional pieces"],
    },
    kpi: "ADS",
    gallery: [...[37, 42, 44, 46, 48, 49, 50, 51, 52, 53, 54].map((n) => `${W}gd/w${n}.jpg`), `${W}gd/w41.jpg`],
  },
  {
    id: "savvy-stand",
    cat: "space",
    client: "Savvy Llama — New York",
    title: { es: "Stand & guía de marca", en: "Stand & brand guidelines" },
    tags: ["Stand", "Guidelines", "Events"],
    stage: "guidelines",
    summary: {
      es: "Diseño del stand y carpa de Savvy Llama para eventos, con su guía de marca: concepto, aplicaciones gráficas, logo, mensajes y paleta.",
      en: "Savvy Llama's event stand and tent design, with its brand guidelines: concept, graphic applications, logo, messaging and palette.",
    },
    strategy: {
      es: "Un espacio rosa y acogedor que invita a entrar en la \"era wine-confident\" y se reconoce desde lejos.",
      en: "A warm pink space that invites people into the \"wine-confident era\" and stands out from afar.",
    },
    results: {
      es: ["Carpa, mantel y señalética", "Guía de marca para eventos", "Sistema de logo, mensajes y color"],
      en: ["Tent, table cover and signage", "Event brand guidelines", "Logo, messaging and colour system"],
    },
    kpi: "EVENT",
    gallery: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((n) => `${W}savvy/stand_${n}.jpg`),
  },
  {
    id: "stands",
    cat: "space",
    client: "La Gloria · Austin Ingenieros Chile",
    title: { es: "Interiores & stands", en: "Interiors & stands" },
    tags: ["Render", "3D", "Events"],
    stage: "stand",
    summary: {
      es: "Renders 3D de interiores para un bar-restaurante y stands para ferias mineras como Exponor y Expomin, llevando la marca al espacio físico.",
      en: "3D interior renders for a bar-restaurant and stands for mining fairs such as Exponor and Expomin, bringing the brand into physical space.",
    },
    strategy: {
      es: "Arquitectura de marca: colores corporativos, gráfica a gran escala y recorridos pensados para el visitante.",
      en: "Brand architecture: corporate colours, large-scale graphics and visitor-friendly flows.",
    },
    results: {
      es: ["Renders 3D de interiores", "Stands y gráfica de gran formato", "Presencia en Exponor y Expomin"],
      en: ["3D interior renders", "Stands and large-format graphics", "Presence at Exponor and Expomin"],
    },
    kpi: "3D",
    gallery: [`${W}gd/s2.jpg`, `${W}gd/s1.jpg`, `${W}gd/s3.png`, `${W}gd/w40.jpg`, `${W}gd/w39.jpg`],
  },
];

export const GRAPHIC_CATS = [
  { id: "branding", n: "01", title: { es: "Branding e identidad visual", en: "Branding & visual identity" } },
  { id: "editorial", n: "02", title: { es: "Diseño gráfico y editorial", en: "Graphic & editorial design" } },
  { id: "flyers", n: "03", title: { es: "Flyers y pósters", en: "Flyers & posters" } },
  { id: "ads", n: "04", title: { es: "Publicidad y marketing", en: "Advertising & marketing" } },
  { id: "space", n: "05", title: { es: "Espacios y stands", en: "Space & stand design" } },
];

export const LOGOS = ["w10", "w02", "w08", "w11", "w07", "w00"];

export const ABOUT = {
  title: { es: "Curiosa, inquieta y obsesionada con el detalle.", en: "Curious, restless and obsessed with detail." },
  p1: {
    es: "Soy Camila Eterovic, diseñadora gráfica chileno‑croata con más de 10 años en branding, marketing digital e identidad corporativa. Hoy creo para Savvy Llama en Nueva York.",
    en: "I'm Camila Eterovic, a Chilean–Croatian graphic designer with 10+ years in branding, digital marketing and corporate identity. Today I create for Savvy Llama in New York.",
  },
  p2: {
    es: "Fundé PÁRAMO, una marca de decoración con formas geométricas en cobre, vidrio y estaño inspiradas en cristales y minerales, que me llevó a enseñar en Domestika. La fotografía, los animales y la naturaleza son mi inspiración; integro IA en mi proceso sin perder lo esencial: estrategia y creatividad.",
    en: "I founded PÁRAMO, a decor brand of geometric copper, glass and tin forms inspired by crystals and minerals, which led me to teach on Domestika. Photography, animals and nature inspire me; I bring AI into my process without losing what matters: strategy and creativity.",
  },
};

export const EXPERIENCE = [
  { co: "Savvy Llama", place: "New York", years: "2025 — ", role: { es: "Diseño de marca, creatividad y marketing digital", en: "Brand design, creative & digital marketing" } },
  { co: "Shady Grove Fertility", place: "Santiago", years: "2022 — 2025", role: { es: "Diseñadora gráfica & community manager", en: "Graphic designer & community manager" } },
  { co: "Adistec", place: "Santiago", years: "2017 — 2022", role: { es: "Diseñadora gráfica", en: "Graphic designer" } },
  { co: "Páramo Store", place: "Chile", years: "2018 — ", role: { es: "Fundadora y directora", en: "Founder & owner" } },
  { co: "Austin Chile", place: "Antofagasta", years: "2009 — 2014", role: { es: "Diseñadora gráfica & marca", en: "Graphic & brand designer" } },
];

export const SERVICES = [
  { n: "01", title: { es: "Identidad de marca", en: "Brand identity" }, text: { es: "Logotipos, sistemas visuales y manuales que hacen que una marca se reconozca en cualquier lugar.", en: "Logotypes, visual systems and guidelines that make a brand recognisable anywhere." }, wide: true },
  { n: "02", title: { es: "Estrategia social", en: "Social strategy" }, text: { es: "Planes a medida para crecer en engagement, seguidores y resultados medibles.", en: "Tailored plans to grow engagement, followers and measurable results." } },
  { n: "03", title: { es: "Motion & video", en: "Motion & video" }, text: { es: "Reels, TikToks, unboxings y motion graphics, del guion a la edición.", en: "Reels, TikToks, unboxings and motion graphics, from script to edit." } },
  { n: "04", title: { es: "Campañas pagadas", en: "Paid campaigns" }, text: { es: "Creatividades para Meta y TikTok Ads, segmentación y análisis de resultados.", en: "Creative for Meta and TikTok Ads, targeting and results analysis." } },
  { n: "05", title: { es: "Editorial & eventos", en: "Editorial & events" }, text: { es: "Catálogos, flyers, señalética y stands para ferias y lanzamientos.", en: "Catalogues, flyers, signage and stands for fairs and launches." } },
];

export const TOOLS = ["Photoshop", "Illustrator", "InDesign", "Premiere Pro", "Meta Ads", "TikTok Ads", "Shopify", "Klaviyo", "AI"];

export const CLIENTS = ["Savvy Llama", "Shady Grove Fertility", "Adistec", "VMware", "Veritas", "Fortinet", "Pure Storage", "Entel", "Movistar", "Claro", "Austin Ingenieros", "Domestika"];

export const QUOTES = [
  { q: { es: "Camila es una profesional creativa, proactiva y con gran capacidad de liderazgo. Siempre supo transmitir ideas innovadoras al equipo.", en: "Camila is a creative, proactive professional with great leadership. She always knew how to bring innovative ideas to the team." }, who: "Rodrigo Montan", role: { es: "Jefe de Comunicaciones y Marketing, SG Fertility", en: "Head of Communications & Marketing, SG Fertility" } },
  { q: { es: "Su visión estratégica en branding y marketing digital ha generado un impacto real en nuestros proyectos.", en: "Her strategic vision in branding and digital marketing has had a real impact on our projects." }, who: "Paula Saiz", role: { es: "Field Marketing Manager Latam, Liferay", en: "Field Marketing Manager Latam, Liferay" } },
];

export const CONTACT = {
  email: "camilaeterovic.s@gmail.com",
  phone: "+34 656 734 783",
  title1: { es: "Hagamos algo", en: "Let's make something" },
  title2: { es: "que se mueva.", en: "that moves." },
  types: [
    { es: "Branding", en: "Branding" },
    { es: "Redes sociales", en: "Social media" },
    { es: "Motion", en: "Motion" },
    { es: "Otro", en: "Other" },
  ],
};
